var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-result',{attrs:{"subTitle":"抱歉，您访问的页面不见了"}},[_c('template',{slot:"icon"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }